export type BulkDownloadJobStatus = 'building' | 'ready' | 'failed';

export interface BulkDownloadJobItem {
  jobId: string;
  fileIds: string[];
  fileNames: string[];
  status: BulkDownloadJobStatus;
  downloadUrl?: string;
  fileName: string;
}

export function buildBulkDownloadFileName(contextName?: string | null): string {
  const now = new Date();
  const datePart = now.toISOString().slice(0, 10); // yyyy-MM-dd

  const clean = (contextName ?? '')
    .trim()
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/\s+/g, '_')
    .slice(0, 80);

  if (clean) return `${clean}_${datePart}.zip`;

  const timePart = `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
  return `BulkDownload_${datePart}_${timePart}.zip`;
}
